import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {AbstractDataServiceV2} from '../../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {Scan3dGroupModel} from '../../../api/entity/scan3dGroup.model';
import {Scan3dGroupConverter} from '../../../api/entity/converter/scan3dGroup.converter';
import {CustomizeHttpUrlGenerator} from '../../../../../../../store/core/url/customizeHttpUrlGenerator';

@Injectable()
export class Scan3dGroupDataService extends AbstractDataServiceV2<Scan3dGroupModel, Scan3dGroupConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator, logger: Logger, config: DefaultDataServiceConfig,
                converter: Scan3dGroupConverter) {
        super('Scan3dGroup', http, httpUrlGenerator, logger, config, converter);
    }
}
